import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { StaffsHelpbuttonService } from '../../../services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-staffs-dashboard',
  templateUrl: './helpbutton-staffs-dashboard.component.html',
  styleUrls: ['./helpbutton-staffs-dashboard.component.scss']
})
export class HelpbuttonStaffsDashboardComponent implements OnInit, OnDestroy {

  staffs;
  noItemsConfig;
  viewDisposition = 'grid';
  getStaffsSubscription: Subscription;
  getStaffsSubscriptionRefresh: Subscription;
  searchStaffsSubscription: Subscription;
  filterStaffsSubscription: Subscription;
  toggleStaffsDispositionSubscription: Subscription;
  filterKey;
  filterOpts;

  constructor(private staffsService: StaffsHelpbuttonService,
              private router: Router,
              private cd: ChangeDetectorRef,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.staffs = this.getStaffs();
    this.getStaffsSubscriptionRefresh = this.staffsService.refreshStaffsListen().subscribe(
      (res) => {
        this.getStaffs();
      }
    );
    this.filterStaffsSubscription = this.staffsService.filterStaffsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchStaffsSubscription = this.staffsService.searchStaffsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleStaffsDispositionSubscription = this.staffsService.toggleStaffsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getStaffs() {
    this.getStaffsSubscription = this.staffsService.getStaffs().subscribe(
      (res) => {
        this.staffs = res;
      },
      (error) => {
        this.router.navigate(['../../'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user-cog', 'helpbutton-page.staffs', '/helpbutton', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.staffs')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'helpbutton-page.staffs not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getStaffsSubscription) { this.getStaffsSubscription.unsubscribe(); }
    if (this.getStaffsSubscriptionRefresh) { this.getStaffsSubscriptionRefresh.unsubscribe(); }
    if (this.searchStaffsSubscription) { this.searchStaffsSubscription.unsubscribe(); }
    if (this.filterStaffsSubscription) { this.filterStaffsSubscription.unsubscribe(); }
    if (this.toggleStaffsDispositionSubscription) { this.toggleStaffsDispositionSubscription.unsubscribe(); }
  }

}
